"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageReducerBase = void 0;
var tslib_1 = require("tslib");
var pageReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === 'REACHED_MAX_PAGE_ACTION') {
        return tslib_1.__assign(tslib_1.__assign({}, state), { reachMaxPage: action.value });
    }
    if (action.type === 'INCREMENT_PAGE_ACTION') {
        var currentPage = (state === null || state === void 0 ? void 0 : state.page) || 0;
        var newPage = currentPage + action.value;
        return tslib_1.__assign(tslib_1.__assign({}, state), { page: newPage });
    }
    if (action.type === 'GETTING_PAGE_DATA_ACTION') {
        return tslib_1.__assign(tslib_1.__assign({}, state), { gettingPageData: action.value });
    }
    if (action.type ===
        'CLEAR_PAGE_ACTION' /* commenting out because we dont need the use case, afraid of bugs in egg kat though  || action.type == 'LOCATION_CHANGE' */) {
        return null;
    }
    return state || null;
};
exports.pageReducerBase = pageReducerBase;
